import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import CurrentProject from '../components/CurrentProject'

import arrowBottom from '../images/arrow-bottom.svg'
import mauriceLogo from '../images/Maurice_Logo_header.svg'

if (typeof window !== 'undefined') {
  // Make scroll behavior of internal links smooth
  // eslint-disable-next-line global-require
  require('smooth-scroll')('a[href*="#"]')
}

const Wrapper = styled.section`
  position: relative;
  min-height: 300px;
`

const HeaderWrapper = styled.div`
  width: 100vw;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  animation-duration: 1s;
  animation-delay: 0;
`

const BackgroundHeaderImg = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  z-index: -1;
  height: ${props => props.height};
  @media (min-width: 36em) {
    height: 100vh;
  }
  // Adjust image positioning (if image covers area with defined height) and add font-family for polyfill
  & > img {
    object-fit: cover !important; // or whatever
    object-position: 0% 0% !important; // or whatever
    font-family: 'object-fit: cover !important; object-position: 0% 0% !important;'; // needed for IE9+ polyfill
  }
`

const ViewProjects = styled.a`
  position: absolute;
  bottom: 30px;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    bottom: 30px;
  }
  color: #fff;
  text-transform: uppercase;
  font-size: 18px;
  letter-spacing: 1px;
  text-decoration: none;
  img {
    display: inline;
    margin: 0 5px 0 0;
    width: 18px;
    filter: invert(1);
  }
`
const HeaderTitleWrapper = styled.div`
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  text-align: center;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 1s ease-in-out;
`

const HeaderTitle = styled.h1`
  margin: 0;
  text-align: center;
  animation-duration: 1s;
  animation-delay: 1.2s;
  position: relative;
  padding-top: 4vh;
  padding-right: 1vh;
  img {
    width: 50vw;
    max-width: 800px;
    margin: 0 auto;
  }
`

class HeroHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: '100vh',
    }
  }

  componentDidMount() {
    this.setState({
      height: window.innerHeight + 'px',
    })
  }
  render() {
    var projectPost =
      this.props.photoSet[1].photo.fluid != null
        ? this.props.photoSet[1].photo.fluid
        : this.props.photoSet[0].photo.fluid

    return (
      <Wrapper>
        <HeaderWrapper>
          <BackgroundHeaderImg
            // height={this.props.height}
            fluid={this.props.heroImage.fluid}
            backgroundColor={'#eeeeee'}
            height={this.state.height}
          />

          <HeaderTitleWrapper visible={!this.props.animationPlaying}>
            <HeaderTitle>
              <img src={mauriceLogo} alt="Maurice van der Meijs" />
            </HeaderTitle>
          </HeaderTitleWrapper>

          <ViewProjects
            href="#work-list"
            className="animated pulse infinite slow delay-3s"
          >
            <img src={arrowBottom} alt="View Projects" />
            View Projects
          </ViewProjects>
          <CurrentProject slug={this.props.slug} projectPost={projectPost} dark={true} />
        </HeaderWrapper>
      </Wrapper>
    )
  }
}
export default HeroHeader
